import Vue from 'vue'
import VueI18n from 'vue-i18n'
import store from './store/index'

Vue.use(VueI18n)

// Wenn eine neue Sprache hinzu kommt, dann muss die im Store in das Language-Array
// Zudem muss das mit sfData abgeglichen werden, was für Languages da a) im Enum vorgesehen sind und b) überhaupt von SF unterstützt werden/ vorgesehen sind

function loadLocaleMessages () {
  const locales = require.context('./locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
  const messages = {}
  locales.keys().forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i)
    if (matched && matched.length > 1) {
      const locale = matched[1]
      messages[locale] = locales(key)
    }
  })
  return messages
}

export default new VueI18n({
  //Die Standardsprachen. Wenn von SF das Languages-Array geschickt wird, dann muss
  //Geguckt werden, ob die im Query angefragte Sprache dabei ist. Wenn Match, dann gut.
  //Sonst: Versuch, Abgleich 'EN_US'. Sonst 'EN_UK'. Sonst 'de_DE'. Usw. Es muss sichergestellt sein, dass dies nicht erschöpfbar ist!!
  locale: store.state.pickedLanguage || 'en_GB',
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'en_GB',
  messages: loadLocaleMessages()
})
